import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=7df3b5bc&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=7df3b5bc&prod&scoped=true&lang=css"
import style1 from "./PasswordReset.vue?vue&type=style&index=1&id=7df3b5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df3b5bc",
  null
  
)

export default component.exports